var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kst-section',{attrs:{"title":_vm.sectionTitle}},[_c('kst-table',{attrs:{"view-mode":"","data":_vm.items}},[_c('b-table-column',{attrs:{"field":"Value","label":_vm.VariantValueCatalog.Value.Label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var column = ref.column;
var row = ref.row;
return [_c('kst-value',{attrs:{"field":column.field,"data":row,"catalog":_vm.VariantValueCatalog}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }